import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import {
  Panel,
  PanelHeader,
  PanelBody,
  PanelFooter,
} from "../../../../../Components/Panel/Panel";
import { InputGroup, Input, InputGroupAddon, Button, Alert } from "reactstrap";
import Pagination from "../../../../../Components/Pagination/QSP";
import { currencyName } from "../../../../../Components/User/UserNames";
import qs from "qs";
import downloadExcel from "../../downloadExcel";

import ReactMoment from "react-moment";

const STATUS_FILTERS = [
  { value: "", label: "전체" },
  { value: "C", label: "사용" },
  { value: "S", label: "중지" },
];

export default ({
  location,
  page,
  commonStatus,
  keyword,
  keywordInput,
  blockSize,
  first,
  data,
  loading,
  baseUrl,
  handleSearch,
}) => {
  const queryString = qs.parse(location.search.substr(1));

  const onDownload = () =>
    downloadExcel(
      "gruSavingInfos",
      { commonStatus, keyword },
      "NFC 적립.xlsx"
    );

  const onCopyId = (id) => {
    // NFC 태그에는 "N-{id}" 형태로 기록한다.
    const payload = `N-${id}`;
    if (navigator.clipboard) {
      navigator.clipboard.writeText(payload);
    }
    window.alert(`NFC 기록값이 복사되었습니다.\n\n${payload}`);
  };

  return (
    <>
      <Helmet>
        <title>NFC 적립 관리 | 한밭페이</title>
      </Helmet>
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            <Link to="/dashboard">Home</Link>
          </li>
          <li className="breadcrumb-item active">NFC 적립</li>
        </ol>
        <h1 className="page-header">NFC 적립</h1>

        <div className="row m-b-15">
          <div className="col-xs-12 text-right">
            <button
              type="button"
              className="btn btn-white m-r-5"
              onClick={onDownload}
            >
              <i className="fa fa-download m-r-5"></i>엑셀 다운로드
            </button>
            <Link
              to={`/gruSavingList${location.search}`}
              className="btn btn-white"
            >
              <i className="fa fa-list m-r-5"></i>적립내역
            </Link>
          </div>
        </div>

        <div className="row">
          <div className="col-xl-12">
            {loading && (
              <div className="panel-loader">
                <span className="spinner-small"></span>
              </div>
            )}

            <Panel>
              <PanelHeader noButton={true}>
                목록({!loading && data.AdminGruSavingInfoList.count}건)
              </PanelHeader>
              <Alert className="bg-gray-transparent-1">
                <div>
                  {STATUS_FILTERS.map((item) => {
                    const url =
                      "?" +
                      (item.value ? "commonStatus=" + item.value + "&" : "") +
                      (keyword ? "keyword=" + keyword + "&" : "");
                    return (
                      <Link
                        key={item.value}
                        className={`btn btn-white m-r-5 m-b-5 ${
                          (queryString.commonStatus || "") === item.value
                            ? "active"
                            : ""
                        }`}
                        to={`/gruSavings${url}`}
                      >
                        {item.label}
                      </Link>
                    );
                  })}
                </div>
                <form onSubmit={handleSearch}>
                  <InputGroup>
                    <Input
                      type="text"
                      className="input-white"
                      placeholder="검색어(명칭, 가맹점명) 입력"
                      value={keywordInput.value}
                      onChange={keywordInput.onChange}
                    />
                    <InputGroupAddon addonType="append">
                      <Button size="sm" color="white">
                        <i className="fa fa-search fa-fw"></i>
                      </Button>
                    </InputGroupAddon>
                  </InputGroup>
                </form>
              </Alert>
              {!loading && data.AdminGruSavingInfoList.count > 0 ? (
                <>
                  <PanelBody>
                    <div className="table-responsive">
                      <table className="table table-bordered table-striped m-b-0">
                        <thead>
                          <tr>
                            <th>상태</th>
                            <th>가맹점명</th>
                            <th>명칭</th>
                            <th>적립 금액</th>
                            <th>위치 검증</th>
                            <th>적립 횟수</th>
                            <th>적립 합계</th>
                            <th>등록일시</th>
                            <th>기능</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data.AdminGruSavingInfoList.gruSavingInfos.map(
                            (item) => {
                              return (
                                <tr key={item.id}>
                                  <td>
                                    {item.commonStatus === "C" && "사용"}
                                    {item.commonStatus === "S" && "중지"}
                                  </td>
                                  <td>{item.store.name}</td>
                                  <td>{item.name}</td>
                                  <td className="text-right">
                                    {item.amount.toLocaleString()}
                                    {currencyName(item.currency)}
                                  </td>
                                  <td>
                                    {item.isLocationCheck ? "사용" : "미사용"}
                                  </td>
                                  <td className="text-right">
                                    {(item.gruSavingCount || 0).toLocaleString()}
                                    건
                                  </td>
                                  <td className="text-right">
                                    {(
                                      item.gruSavingAmount || 0
                                    ).toLocaleString()}
                                    {currencyName(item.currency)}
                                  </td>
                                  <td>
                                    <ReactMoment format="YYYY-MM-DD HH:mm:ss">
                                      {item.createdAt}
                                    </ReactMoment>
                                  </td>
                                  <td>
                                    <button
                                      type="button"
                                      className="btn btn-white btn-xs text-blue m-r-5"
                                      onClick={() => onCopyId(item.id)}
                                    >
                                      NFC값 복사
                                    </button>
                                    <Link
                                      className="btn btn-white btn-xs text-green m-r-5"
                                      to={`/gruSavings/${item.id}/edit${location.search}`}
                                    >
                                      수정
                                    </Link>
                                    <Link
                                      className="btn btn-white btn-xs text-black"
                                      to={`/gruSavingList?gruSavingInfo=${item.id}`}
                                    >
                                      적립내역
                                    </Link>
                                  </td>
                                </tr>
                              );
                            }
                          )}
                        </tbody>
                      </table>
                    </div>
                  </PanelBody>
                  <PanelFooter>
                    <div className="row">
                      <div className="col-md-6">
                        <Pagination
                          totalRecord={data.AdminGruSavingInfoList.count}
                          blockSize={blockSize}
                          pageSize={first}
                          currentPage={page}
                          baseUrl={baseUrl}
                        />
                      </div>
                      <div className="col-md-6"></div>
                    </div>
                  </PanelFooter>
                </>
              ) : (
                <PanelBody>
                  <p className="text-center">등록된 데이터가 없습니다.</p>
                </PanelBody>
              )}
            </Panel>
          </div>
        </div>
      </div>
      <Link
        to={`/gruSavings/write${location.search}`}
        className="btn btn-icon btn-circle btn-lg btn-primary btn-scroll-to-top"
      >
        <i className="fas fa-pencil-alt"></i>
      </Link>
    </>
  );
};
